import { $ } from '@/Engine/state';

export const onEscapeHandler = () => {
    // TODO
    $.render();
};
